import React from 'react';

// Grain-dryer outline for the Dryer State tile, the same drawing the phone
// app uses: roof cap, drying tower with side ladder, fan row, legs. Strokes
// use currentColor so the tile's state colour tints the whole picture.
const DryerIcon = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M11.45 3.6 V2.3 H13.95 V3.6" />
    <path d="M7.2 18.6 V7.2 L10.6 3.6 H14.8 L18.2 7.2 V18.6 Z" />
    <path d="M7.2 13.4 H18.2" />
    <circle cx="9.45" cy="16" r="1.3" />
    <circle cx="12.7" cy="16" r="1.3" />
    <circle cx="15.95" cy="16" r="1.3" />
    <path d="M7.2 8.4 H5.3 V12.6 H7.2 M5.3 10.5 H7.2" />
    <path d="M8.1 18.6 V20.5 M7.1 20.5 H9.1 M17.3 18.6 V20.5 M16.3 20.5 H18.3" />
  </svg>
);

export default DryerIcon;
